import React, { useState } from "react";

const MessageContent = () => {
  const [message, setMessage] = useState("");

  const handleSendMessage = () => {
    console.log("Sending Message:", message);
    setMessage(""); // Clear the message input after sending
  };

  return (
    <div className="w-full bg-white max-h-[calc(100vh-320px)] overflow-auto p-6 flex flex-col h-full">
      {/* Message Header */}

      <div className="">
        <div className="flex flex-col">
          <p className="font-semibold text-gray-900">Nitesh Chowdhary</p>
          <p className="text-sm text-gray-500">
            <span className="font-medium">Mobile</span> • 1h ago
          </p>
        </div>

        <div className="flex items-center space-x-4 mb-4">
          {/* Message Content */}
          <img
            src="https://via.placeholder.com/40/green/ffffff?text=NC"
            alt="User Avatar"
            className="rounded-full w-12 h-12 object-cover"
          />
          <div className="mb-4">
            <p className="text-base text-gray-800">
              <span className="font-semibold">Nitesh Chowdhary</span> (He/Him) •
              1st
            </p>
            <p className="text-sm text-gray-600 mt-2">
              JavaScript Developer | Mobile App Developer
            </p>
            <p className="text-sm text-gray-600 mt-2">
              <span className="font-semibold">Feb 24</span> • 9:25 AM
            </p>
          </div>
        </div>
      </div>

      {/* Message Input */}
      <div className="flex items-center space-x-2 mt-auto">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write a message..."
          className="flex-grow p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleSendMessage}
          className="px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700"
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default MessageContent;
